import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShellAndTubeHeatExchanger3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 30,
		cy: 30,
		rx: 30,
		ry: 30,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 30.0 60.0 L 30.0 45.0 L 20.0 45.0 L 40.0 15.0 L 30.0 15.0 L 30.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgShellAndTubeHeatExchanger3;
